interface LogData {
  [key: string]: any;
}

class Logger {
  private static instance: Logger;
  private debugMode: boolean;

  private constructor() {
    this.debugMode = process.env.REACT_APP_DEBUG_MODE === 'true';
  }

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private formatMessage(message: string, data?: LogData): string {
    if (data) {
      return `${message} - Data: ${JSON.stringify(data)}`;
    }
    return message;
  }

  public debug(message: string, data?: LogData): void {
    if (this.debugMode) {
      console.debug(`[DEBUG] ${this.formatMessage(message, data)}`);
    }
  }

  public info(message: string, data?: LogData): void {
    console.info(`[INFO] ${this.formatMessage(message, data)}`);
  }

  public error(message: string, errorOrData?: Error | LogData): void {
    if (errorOrData instanceof Error) {
      console.error(`[ERROR] ${message} - Error: ${errorOrData.message}`, errorOrData);
    } else if (errorOrData) {
      console.error(`[ERROR] ${this.formatMessage(message, errorOrData)}`);
    } else {
      console.error(`[ERROR] ${message}`);
    }
  }

  public warn(message: string, data?: LogData): void {
    console.warn(`[WARN] ${this.formatMessage(message, data)}`);
  }
}

export const logger = Logger.getInstance(); 